import { gql } from '@/__generated__';

// Separada de `GET_GATE_LIMITS_DATA`: tarda hasta ~25 s y no puede retener el formulario.
export const GET_GATE_LIVE_STATUS = gql(`#graphql
  query GetGateLiveStatus($gateId: ID!) {
    gate(input: { id: $gateId }) {
      id
      liveStatus {
        outcome
        code
        message
        reading {
          position
          minPosition
          maxPosition
          moving
          movementId
          batteryLevel
          blockedBy
          blockedOpenBy
          blockedCloseBy
        }
      }
    }
  }
`);
